import { lazyLoad } from 'utils/lazy';

export default lazyLoad(
  () => import('./Update'),
  (m) => m.default
);
